import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resources as opsReportsResources } from '@atlassian/eoc-ops-reports-common/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGlobalReportsNav4Route } from '@jira/router-routes__eoc-reports-routes/src/eocGlobalReportsNav4Route.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { GlobalOpsReports, LazyGlobalOpsReports } from './ui/spa/eoc/ops-reports/index.tsx';

export const eocGlobalReportsNav4RouteEntry: Route = createEntry(eocGlobalReportsNav4Route, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: GlobalOpsReports,

	resources: [
		...getNavigationResources(),
		...opsReportsResources(),
		getConsolidationStateResource(),
	],

	navigation: {
		menuId: MenuIdHome,
	},

	forPaint: [LazyAtlassianNavigation, LazyGlobalOpsReports],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
